import React from 'react'
import Tag from '../../assets/images/png/tag-icon.png'
import Location from '../../assets/images/png/location-icon.png'
import Clock from '../../assets/images/png/green-clock-icon.png'
import likeicon from '../../assets/images/png/like-icon.png'
import wishlistSelectedIcon from '../../assets/images/png/wishlistSelectedIcon.png'
import ReactPaginate from 'react-paginate'
import { useNavigate } from 'react-router-dom'
import { addProducttoWishlist } from '../../services/WishlistServices'
import { nextPaginationArrow, prevPaginationArrow } from '../SvgPaths/SvgPaths'

const ProductList = ({
  data,
  favouriteItems,
  getWishlistItems,
  totalPages,
  handlePageChange,
  productsToBeShown
}) => {
  const navigate = useNavigate()

  const addToWishlist = async id => {
    const tokenitem = localStorage.getItem('token')
    if (tokenitem) {
      const productId = id
      await addProducttoWishlist(productId, tokenitem)
      getWishlistItems()
    } else {
      localStorage.setItem('path', '/farmer-shop')
      navigate('/signin')
    }
  }

  const isInWishlist = id => {
    return (
      favouriteItems && favouriteItems.some(item => item?.productId?._id === id)
    )
  }

  function convertToRelativeTime (createdAt) {
    const currentTime = new Date()
    const createdTime = new Date(createdAt)
    const timeDifference = Math.abs(currentTime - createdTime)

    const seconds = Math.floor(timeDifference / 1000)
    const minutes = Math.floor(seconds / 60)
    const hours = Math.floor(minutes / 60)
    const days = Math.floor(hours / 24)

    if (days > 0) {
      return `${days} day${days > 1 ? 's' : ''} ago`
    } else if (hours > 0) {
      return `${hours} hour${hours > 1 ? 's' : ''} ago`
    } else if (minutes > 0) {
      return `${minutes} minute${minutes > 1 ? 's' : ''} ago`
    } else {
      return `just now`
    }
  }

  return (
    <div className='row px-2 mt-2'>
      {data?.map((item, index) => {
        return (
          <div className='col-sm-6 col-lg-4 p-2 cursor-pointer' key={index}>
            <div className='h-100'>
              <div className='rounded-3 product-border bg-light-green h-100 d-flex flex-column justify-content-between'>
                <div onClick={() => navigate(`/profile-details/${item?._id}`)}>
                  <div
                    style={{ borderRadius: '8px 8px 0 0' }}
                    className='position-relative bg-white'
                  >
                    <span
                      className={`position-absolute top-0 end-0 mt-2 text-white py-1 px-3 rounded-2 me-2 fs_3xsm ${
                        item?.adType === 'sales'
                          ? 'bg-danger'
                          : item?.adType === 'lease'
                          ? 'bg-primary'
                          : 'bg-success'
                      } ff_heebo fs_3xsm text-capitalize`}
                    >
                      {item?.adType}
                    </span>
                    {item?.images[0] ? (
                      <img
                        height={200}
                        style={{ borderRadius: '8px 8px 0 0' }}
                        className='w-100 object-fit-cover'
                        src={item?.images[0]}
                        alt='Image'
                      />
                    ) : (
                      <img
                        height={200}
                        style={{ borderRadius: '8px 8px 0 0' }}
                        className='w-100 object-fit-cover'
                        src={
                          'https://savr-dev-bucket.s3.amazonaws.com/83b1a7b1-728b-4f45-9615-1b7b86b572b4'
                        }
                        alt='Image'
                      />
                    )}
                  </div>
                  <div className='px-3 pt-3'>
                    <div className='d-flex align-items-center'>
                      <img src={Tag} alt='tag' />{' '}
                      <span className='clr_dark_green ff_heebo fs_3xsm ms-3'>
                        {item?.machineType} / Agri Equipments
                      </span>
                    </div>
                    <h3 className='ff_heebo fs_md my-3 fw-semibold clr_dark_blue'>
                      {item?.name}
                    </h3>
                  </div>
                </div>
                <div className='px-3'>
                  <div className='d-flex align-items-center'>
                    <div>
                      <img className='mb-10' src={Location} alt='tag' />
                    </div>{' '}
                    <span className='clr_dark_green ff_heebo fs_3xsm ms-1'>
                      {item?.location}
                    </span>
                    <div className='ms-3'>
                      {' '}
                      <img className='mb-10' src={Clock} alt='tag' />
                    </div>{' '}
                    <span className='clr_dark_green ff_heebo fs_3xsm ms-1'>
                      {convertToRelativeTime(item?.createdAt)}
                    </span>
                  </div>
                  <hr />
                  <div className='d-flex align-items-center justify-content-between pb-3'>
                    <div className='d-flex align-items-center gap-2'>
                      <div
                        onClick={() => {
                          addToWishlist(item._id)
                        }}
                        className='d-flex'
                      >
                        {isInWishlist(item?._id) ? (
                          <img
                            className='postion-relative z-3'
                            width={18}
                            src={wishlistSelectedIcon}
                            alt='wishlistIcon'
                          />
                        ) : (
                          <img
                            className='postion-relative z-3'
                            width={18}
                            src={likeicon}
                            alt='wishlistIcon'
                          />
                        )}
                      </div>
                      <div
                        onClick={() => navigate('/profile-details')}
                        className='vr-line'
                      ></div>
                    </div>
                    <div
                      onClick={() => navigate(`/profile-details/${item?._id}`)}
                      className='d-flex align-items-center w-100 justify-content-end'
                    >
                      <span className='fw-bold ff_heebo fs_md clr_dark_blue'>
                        ₹{item?.price}
                      </span>
                      <span className='clr_dark_green ff_heebo fs_3xsm'>
                        /{item?.priceType}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )
      })}
      <div className='hr-line mt-4'></div>
      <div className='d-flex flex-column flex-sm-row gap-3 mt-2 align-items-center justify-content-between'>
        <p className='mb-0 ff_heebo fw-medium fs_xsm clr_dark_grey_3'>
          Showing {productsToBeShown} - {data?.length} of {data?.length} results
        </p>
        <div className='pagination-container'>
          <ReactPaginate
            previousLabel={prevPaginationArrow}
            nextLabel={nextPaginationArrow}
            pageCount={totalPages > 0 ? totalPages : 1}
            onPageChange={handlePageChange}
            containerClassName={'pagination justify-content-end mb-0'}
            previousLinkClassName={'pagination__link'}
            nextLinkClassName={'pagination__link'}
            pageClassName={
              'pagination__page d-flex align-items-center justify-content-center clr_dark_grey_3 mx-1 ff_heebo fw-medium fs_xsm'
            }
            disabledClassName={'pagination__link--disabled'}
            activeClassName={
              'pagination__link--active d-flex align-items-center justify-content-center text-white ff_heebo fw-medium fs_xsm'
            }
          />
        </div>
      </div>
    </div>
  )
}

export default ProductList
